module.exports = __webpack_public_path__ + "img/img-not-opened.bf59b8d5.png";